const Forms = () => null;

export default Forms;
